// ==========================================================================
// Squarebit Store - Copyright (c) 2026 Squarebit LLC. All rights reserved.
// Proprietary and confidential. Not for redistribution.
// ==========================================================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import { DocH2, DocH3, DocP, DocList } from './doc-bits.component';

/**
 * Getting the module in place and activated.
 *
 * The steps describe the drag and drop installer, which is what 1.11.0 ships
 * and what does the module path work for you. Placing it by hand is its own
 * section rather than the main route: a studio putting one copy on a share for
 * a number of machines still needs it, and the troubleshooting refers to it.
 */
const InstallDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      <DocH2 id="install">{t('sbframework.docs.title')}</DocH2>
      <DocP>{t('sbframework.docs.intro')}</DocP>

      <DocH3 id="steps">Steps</DocH3>
      <DocList
        ordered
        items={[1, 2, 3, 4].map((n) => (
          <>
            <strong>{t(`sbframework.docs.step${n}Title`)}</strong>
            <br />
            {t(`sbframework.docs.step${n}Body`)}
          </>
        ))}
      />

      <DocH3 id="by-hand">{t('sbframework.docs.manualTitle')}</DocH3>
      <DocP>{t('sbframework.docs.manualBody')}</DocP>

      <DocH3 id="troubleshooting">{t('sbframework.docs.troubleTitle')}</DocH3>
      <DocList
        items={[
          t('sbframework.docs.troubleNoMenu'),
          t('sbframework.docs.troubleBadKey'),
          t('sbframework.docs.troubleSeats'),
          t('sbframework.docs.troubleClock')
        ]}
      />
    </article>
  );
};

export default InstallDoc;
